let isSidePanelVoiceCallStartingOrActive = false;
let endSidePanelVoiceCallForQuestionNavigationHandler: (() => void) | null = null;

export function setSidePanelVoiceCallStartingOrActive(isStartingOrActive: boolean): void {
  isSidePanelVoiceCallStartingOrActive = isStartingOrActive;
}

export function getIsSidePanelVoiceCallStartingOrActive(): boolean {
  return isSidePanelVoiceCallStartingOrActive;
}

export function setEndSidePanelVoiceCallForQuestionNavigationHandler(handler: (() => void) | null): void {
  endSidePanelVoiceCallForQuestionNavigationHandler = handler;
}

export function endSidePanelVoiceCallForQuestionNavigation(): boolean {
  if (!isSidePanelVoiceCallStartingOrActive || !endSidePanelVoiceCallForQuestionNavigationHandler) {
    return false;
  }
  endSidePanelVoiceCallForQuestionNavigationHandler();
  return true;
}

export function shouldBlockQuestionNavigationArrowKey(key: string): boolean {
  return isSidePanelVoiceCallStartingOrActive && (key === "ArrowLeft" || key === "ArrowRight");
}
